import RolesService from "../../services/roles.service";

const state = {

    permissions: [],
    roles: [],
    rolesWithPermissions: [],

};

const mutations = {

    set_permissions(state, payload) {
        state.permissions = payload;
    },

    clear_permissions(state)
    {
      state.permissions = []
    },

    set_roleswithpermission(state, payload) {
        state.rolesWithPermissions = payload;
    },

    clear_roleswithpermission(state)
    {
      state.rolesWithPermissions = []
    },

    set_roles(state, payload) {
        state.roles = payload;
    },

    clear_roles(state)
    {
      state.roles = []
    }
};
const actions = {
    async GetPermissions({commit}) {
        await commit("clear_permissions");
        const permissions = await RolesService.GetPermissionsService();
        await commit("set_permissions", permissions);
        return permissions
    },
    async GetRolesWithPermission({commit}) {
        await commit("clear_roleswithpermission");
        const roleswithpermissions = await RolesService.GetRolesWithPermission();
        // console.log(roleswithpermissions);
        await commit("set_roleswithpermission", roleswithpermissions);
        return roleswithpermissions
    },
    async GetRoles({commit}) {
        await commit("clear_roles")
        const roles = await RolesService.GetRoles();
        await commit("set_roles", roles);
        return roles
    },
    async addPermissionRole({dispatch}, payload,) {
        const addrolepermission = await RolesService.AddPermissionRole(payload);
        dispatch('GetRolesWithPermission');
        return addrolepermission;
    },
    async deletePermissionRole({dispatch, commit}, payload) {
        const deleterolepermission = await RolesService.DeletePermissionRole(payload);
        commit("set_clear");
        dispatch('GetRolesWithPermission');
        return deleterolepermission;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
